import React from 'react';
import { ReactComponent as Textbox } from 'assets/images/icons/question-type/textbox.svg';
import { ReactComponent as Checkbox } from 'assets/images/icons/question-type/checkbox.svg';
import { ReactComponent as Radio } from 'assets/images/icons/question-type/radio.svg';
import { ReactComponent as Score } from 'assets/images/icons/question-type/score.svg';
import { ReactComponent as Rank } from 'assets/images/icons/question-type/rank.svg';
import { ReactComponent as MatrixRadio } from 'assets/images/icons/question-type/matrix-radio.svg';
import { ReactComponent as MatrixCheckbox } from 'assets/images/icons/question-type/matrix-checkbox.svg';
import { ReactComponent as MatrixText } from 'assets/images/icons/question-type/matrix-text.svg';
import { ReactComponent as Dropdown } from 'assets/images/icons/question-type/dropdown.svg';
import { ReactComponent as Date } from 'assets/images/icons/question-type/date.svg';
import { ReactComponent as Number } from 'assets/images/icons/question-type/number.svg';
import { ReactComponent as ScoreStarFull } from 'assets/images/icons/question-type/score-star-full.svg';
import { ReactComponent as ScoreStarHalf } from 'assets/images/icons/question-type/score-star-half.svg';
import { ReactComponent as SliderScale } from 'assets/images/icons/question-type/slider-scale.svg';
import { ReactComponent as Emoji } from 'assets/images/icons/question-type/emoji.svg';
import { ReactComponent as TextboxSeclected } from 'assets/images/icons/question-type/textbox-selected.svg';
import { ReactComponent as CheckboxSelected } from 'assets/images/icons/question-type/checkbox-selected.svg';
import { ReactComponent as RadioSelected } from 'assets/images/icons/question-type/radio-selected.svg';
import { ReactComponent as ScoreSelected } from 'assets/images/icons/question-type/score-selected.svg';
import { ReactComponent as RankSelected } from 'assets/images/icons/question-type/rank-selected.svg';
import { ReactComponent as MatrixRadioSelected } from 'assets/images/icons/question-type/matrix-radio-selected.svg';
import { ReactComponent as MatrixCheckboxSelected } from 'assets/images/icons/question-type/matrix-checkbox-selected.svg';
import { ReactComponent as MatrixTextSelected } from 'assets/images/icons/question-type/matrix-text-selected.svg';
import { ReactComponent as DropDownSelected } from 'assets/images/icons/question-type/dropdown-selected.svg';
import { ReactComponent as DateSelected } from 'assets/images/icons/question-type/date-selected.svg';
import { ReactComponent as NumberSelected } from 'assets/images/icons/question-type/number-selected.svg';
import { ReactComponent as ScoreStarFullSelected } from 'assets/images/icons/question-type/score-star-full-selected.svg';
import { ReactComponent as ScoreStarHalfSelected } from 'assets/images/icons/question-type/score-star-half-selected.svg';
import { ReactComponent as SliderSelected } from 'assets/images/icons/question-type/slider-scale-selected.svg';
import { ReactComponent as EmojiSelected } from 'assets/images/icons/question-type/emoji-selected.svg';
import { ReactComponent as Image } from 'assets/images/icons/question-type/image.svg';
import { ReactComponent as ImageSelected } from 'assets/images/icons/question-type/image-selected.svg';
import { ReactComponent as ImageWithTitle } from 'assets/images/icons/question-type/image-with-title.svg';
import { ReactComponent as ImageWithTitleSelected } from 'assets/images/icons/question-type/image-with-title-selected.svg';
import { ReactComponent as TextboxRecomend } from 'assets/images/icons/question-type/textbox-recomend.svg';
import { ReactComponent as TextboxRecomendSelected } from 'assets/images/icons/question-type/textbox-recomend-selected.svg';
import { ReactComponent as TexboxMultiChoice } from 'assets/images/icons/question-type/textbox-recomend-multi-choice.svg';
import { ReactComponent as TexboxMultiChoiceSelected } from 'assets/images/icons/question-type/texbox-recomend-multi-choice-selected.svg';
import { QuestionType } from 'pages/admin/campaign-overview/constants';

interface IQuestionTypeOption {
    label: string;
    value: string;
    icon: React.ReactNode;
    iconSelected?: React.ReactNode;
}

export const questionTypeOptions: IQuestionTypeOption[] = [
    {
        label: 'Textbox',
        value: QuestionType.Textbox,
        icon: <Textbox />,
        iconSelected: <TextboxSeclected />,
    },
    {
        label: 'Checkbox',
        value: QuestionType.Checkbox,
        icon: <Checkbox />,
        iconSelected: <CheckboxSelected />,
    },
    {
        label: 'Single choice',
        value: QuestionType.SingleChoice,
        icon: <Radio />,
        iconSelected: <RadioSelected />,
    },
    {
        label: 'Score',
        value: QuestionType.Score,
        icon: <Score />,
        iconSelected: <ScoreSelected />,
    },
    {
        label: 'Rank',
        value: QuestionType.Rank,
        icon: <Rank />,
        iconSelected: <RankSelected />,
    },
    {
        label: 'Matrix radio',
        value: QuestionType.MatrixRadio,
        icon: <MatrixRadio />,
        iconSelected: <MatrixRadioSelected />,
    },
    {
        label: 'Matrix checkbox',
        value: QuestionType.MatrixCheckbox,
        icon: <MatrixCheckbox />,
        iconSelected: <MatrixCheckboxSelected />,
    },
    {
        label: 'Matrix text',
        value: QuestionType.MatrixText,
        icon: <MatrixText />,
        iconSelected: <MatrixTextSelected />,
    },
    {
        label: 'Dropdown',
        value: QuestionType.Dropdown,
        icon: <Dropdown />,
        iconSelected: <DropDownSelected />,
    },
    {
        label: 'Date',
        value: QuestionType.Date,
        icon: <Date />,
        iconSelected: <DateSelected />,
    },
    {
        label: 'Number',
        value: QuestionType.Number,
        icon: <Number />,
        iconSelected: <NumberSelected />,
    },
    {
        label: 'Score star (Full)',
        value: QuestionType.ScoreStarFull,
        icon: <ScoreStarFull />,
        iconSelected: <ScoreStarFullSelected />,
    },
    {
        label: 'Score star (Half)',
        value: QuestionType.ScoreStarHalf,
        icon: <ScoreStarHalf />,
        iconSelected: <ScoreStarHalfSelected />,
    },
    {
        label: 'Slider scale',
        value: QuestionType.SliderScale,
        icon: <SliderScale />,
        iconSelected: <SliderSelected />,
    },
    {
        label: 'Emoji',
        value: QuestionType.Emoji,
        icon: <Emoji />,
        iconSelected: <EmojiSelected />,
    },
    {
        label: 'Image',
        value: QuestionType.Image,
        icon: <Image />,
        iconSelected: <ImageSelected />,
    },
    {
        label: 'Image with title',
        value: QuestionType.ImageWithTitle,
        icon: <ImageWithTitle />,
        iconSelected: <ImageWithTitleSelected />,
    },
    {
        label: 'Textbox recommend',
        value: QuestionType.TextboxRecommend,
        icon: <TextboxRecomend />,
        iconSelected: <TextboxRecomendSelected />,
    },
    {
        label: 'Textbox recommend multi choice',
        value: QuestionType.TextboxRecommendMultiChoice,
        icon: <TexboxMultiChoice />,
        iconSelected: <TexboxMultiChoiceSelected />,
    },
];
